import React from 'react';
import Joi from 'joi';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { Input } from 'components/atoms/Input/Input';
import { Button, SocialButton } from 'components/atoms/Button';
import { Header } from 'components/atoms/Header/Header';
import { useFieldset, useDispatchCallback, useAsyncSubmit } from 'controls/hooks';
import { login, googleLogin, facebookLogin } from 'actions/auth';
import { Language } from 'language/Language';
import { strings } from './strings';
import './_Login.scss';
import 'styles/_form.scss';

const loginForm = { email: '', password: '', rememberMe: false };
const loginSchema = {
  email: Joi.string().max(50).required().label('email'),
  password: Joi.string().required().label('password').max(30),
  rememberMe: Joi.boolean().required().label('remember'),
};

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const redirectTo = params.get('redirectTo');

  const handleLoginRedirect = async () => {
    if (!redirectTo) {
      return;
    }
    const isJapanLanguage = language === 'japan';
    const url = isJapanLanguage ? `jp/${redirectTo || ''}` : redirectTo || '';

    params.delete('type');
    params.delete('redirectTo');

    const cleanUrl = `${window.location.pathname}${
      params.toString() ? `?${params.toString()}` : ''
    }`;

    window.history.replaceState({}, '', cleanUrl);
    history.push(`/${url}`);
  };

  const { fields: { email, password, rememberMe }, submit, loading } = useFieldset({
    schema: loginSchema,
    source: loginForm,
    onSubmit: useAsyncSubmit(useDispatchCallback(login), handleLoginRedirect),
  });
  const language = Language();

  const google = () => {
    dispatch(googleLogin());
  };

  const facebook = () => {
    dispatch(facebookLogin());
  };

  return (
    <>
      <form onSubmit={submit} className='form login-form'>
        <Header text={strings[language].title} />
        <Input
          classes='input'
          field={email}
          name={strings[language].email}
          type='email'
        />
        <Input
          classes='input'
          field={password}
          isPassword
          name={strings[language].password}
          type='password'
        />
        <div>
          <Input
            classes='checkbox'
            field={rememberMe}
            name='remember'
            type='checkbox'
          />
          <label style={{ marginLeft: '1rem' }}>{strings[language].remember}</label>
        </div>
        <Button
          className='login__btn'
          loading={loading}
          text={strings[language].signIn}
          type='submit'
        />
        <div>
          <Link
            className='login__callToAction'
            to={`${language === 'japan' ? '/jp/私のアカウント' : '/my-account'}/lost-password?redirectTo=my-account`}
          >
            {strings[language].lostPassword}
          </Link>
        </div>
        <div>
          <p className='login__callToAction'>{strings[language].or}</p>
          <div className='login-buttons'>
            <SocialButton
              text={strings[language].facebook}
              icon='facebook f'
              onClick={facebook}
            />
            <SocialButton
              text={strings[language].google}
              icon='google'
              isImage
              onClick={google}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default Login;
